import { PermissionTemplate } from '@/modules/templateGallery/domain/models/PermissionTemplate'

import { axios, Response } from '../index'

export const updatePermissionTemplateGallery = async (
  templateGalleryId: string,
  permission: PermissionTemplate
): Response<PermissionTemplate> => {
  const payload = permission
  return axios.post(
    `/v1/template-gallery/${templateGalleryId}/permissions`,
    payload
  )
}
export const deletePermissionTemplateGallery = async (
  templateGalleryId: string,
  permissionId: string
) => {
  return axios.delete(
    `/v1/template-gallery/${templateGalleryId}/permissions/${permissionId}`
  )
}
